"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonLink = exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  ", "\n  text-decoration: ", ";\n  cursor: pointer;\n  display: ", ";\n"], ["\n  ", "\n  text-decoration: ", ";\n  cursor: pointer;\n  display: ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"], ["\n  ", "\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  background: none;\n  border: none;\n  padding: 0;\n"], ["\n  ", "\n  background: none;\n  border: none;\n  padding: 0;\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Paragraph = require("./Paragraph");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// font weight, size, color, etc. come from Paragraph
var LinkStyles = (0, _styledComponents.css)(_templateObject, _Paragraph.ParagraphStyle, function (props) {
  return props.underline ? "underline" : "none";
}, function (props) {
  return props.block ? "block" : "inline-block";
});

var defaultProps = {
  color: "primary",
  underline: true,
  fontSize: "bodyMain"
};

var Link = _styledComponents2.default.a.attrs({
  tabIndex: function tabIndex(props) {
    return props.tabIndex || "0";
  }
})(_templateObject2, LinkStyles);

var ButtonLink = _styledComponents2.default.button.withConfig({
  displayName: "Link__ButtonLink",
  componentId: "tb88tb-0"
})(_templateObject3, LinkStyles);

ButtonLink.defaultProps = defaultProps;

Link.defaultProps = defaultProps;

exports.default = Link;
exports.ButtonLink = ButtonLink;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-text/dist/components/Link.js
// module id = 453
// module chunks = 168707334958949